// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"189":"editor","360":"text-widget-editor","428":"viewer","995":"management"}[chunkId] || chunkId) + ".min.js";
};